import ColorScheme from "./colorScheme";
export default ColorScheme;
